import React, { useEffect, useState } from 'react'
import { Button, Dropdown, Header, Icon, Loader, Table } from 'semantic-ui-react'
import { titleProductivityReportInfo, titleProductivityReportInfobyDate } from '../../../app/models/Restoration';
import agent from '../../../app/api/agent';
import { toast } from 'react-toastify';
import { useStore } from '../../../app/stores/store';
import DatePicker from 'react-datepicker';
import moment from 'moment';



const reportoptions = [
  { key: 1, text: 'Title-Wise', value: 'Title-Wise' },
  { key: 2, text: 'Date-Wise', value: 'Date-Wise' },
];


const TitleProductivityReport = () => {
    const{RestorationStore}= useStore() 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loadData, setLoadData] = useState<titleProductivityReportInfo[]>([]);
    const [assignTitleCode, setAssignTitleCode] = useState<{ key: string; text: string; value: string }[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedTitle, setSelectedTitle] = useState<string>('');
    const [selectedReport, setSelectedReport] = useState<string>('');
    const [titleWise, setTitleWise] = useState<titleProductivityReportInfo[]>([]);
    const [dateWise, setDataWise] = useState<titleProductivityReportInfobyDate[]>([]);
    const currentDate = new Date();
    const [startDate, setStartDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
    const [endDate, setEndDate] = useState(() => moment(currentDate).format('MM-DD-YYYY'));
  



    useEffect(() => {
        const fetchTitleCodes = async () => {
          await RestorationStore.getTitleCode();
          const loadTitleCode = RestorationStore.titleCodeData.map((titleCodeList: string) => ({
            key: titleCodeList,
            text: titleCodeList,
            value: titleCodeList,
          }));
          setAssignTitleCode(loadTitleCode);
        };
    
        fetchTitleCodes();
        // eslint-disable-next-line
    }, []);

    const setDate = (data: Date, type: 'start' | 'end') => {
      const formattedDate = moment(data).format('MM-DD-YYYY');
      if (type === 'start') {
        setStartDate(formattedDate);
      } else {
        setEndDate(formattedDate);
      }
    };  

    const handleChangeReport = (e: React.SyntheticEvent<HTMLElement>, data: any)=>{
      setSelectedReport(data.value as string)
    }

    const handleChangeTitle = async (e: React.SyntheticEvent<HTMLElement>, data: any) => {
        const newTitle = data.value as string;
        setSelectedTitle(newTitle);
    };

    const handleViewReport = async () =>{
      setLoading(true);
      if (selectedReport === 'Title-Wise'){
        try{
          const response = await agent.Restoration.titleProductivityReportData(selectedTitle);
          setTitleWise(response.data);
        } catch (error) {
          toast.error('Error fetching report data')
        } finally {
          setLoading(false);
        }  
      } else if (selectedReport === 'Date-Wise'){
        try{
          const response = await agent.Restoration.titleProductivityReportDataByDate(startDate, endDate);
          setDataWise(response.data);
        } catch (error) {
          toast.error('Error fetching report data')
        } finally {
          setLoading(false);
        }  
      }
    }

    const handleDownloadReport = () =>{
      let csvContent = "data:text/csv;charset=utf-8,";

      if (selectedReport === 'Title-Wise'){
        csvContent += "Employee ID,Employee Name,Project Name,Approval Frames,Total Hours,Date Of Floor,Current Date,Tenure,Efficency,Estimate Hour,Total Frames,Target,Actual Target,Productivity %,Rejected Frames,Quality %,Artifacts Frames,Artifacts %\n";
        titleWise.forEach(data => {
            const row = `${data.employeeID},${data.employeeName},${data.project_Name},${data.approved_Frame},${data.totalHours},${data.date_of_Floor},${data.current_Date},${data.tenure},${data.efficency},${data.est_Hour},${data.total_frame},${data.target_frame},${data.actual_Target},${data.productivity},${data.rejectFrame},${data.quality},${data.artifactFrame},${data.qualityofartifact}`;
            csvContent += row + "\n";
        });
      } else if (selectedReport === 'Date-Wise'){
          csvContent += "Employee ID,Employee Name,Project Name,Approval Frames,Total Hours,Date Of Floor,Current Date,Tenure,Efficency,Estimate Hour,Total Frames,Target,Actual Target,Productivity %,Rejected Frames,Quality %,Artifacts Frames,Artifacts %\n";
          dateWise.forEach(data => {
              const row = `${data.employee_Id},${data.employee_Name},${data.project_Name},${data.approval_Frames},${data.total_Hours},${data.dof},${data.current},${data.tenure},${data.efficency},${data.est_Hour},${data.total_Framess},${data.target},${data.actualTarget},${data.productivity_percentage},${data.sum_of_Rejected_Frames},${data.quality_percentage},${data.artifacts_Rejected_Frames},${data.artifacts_Rejection_percentage}`;
              csvContent += row + "\n";
          });
      }

      const date = new Date();
      const formattedDate = date.toISOString().slice(0, 10); 
      const filename = () => {
          if (selectedReport === 'Title-Wise') {
              return `${selectedTitle}_${formattedDate}.csv`;
          } else if (selectedReport === 'Date-Wise') {
              return `from-${startDate}_to-${endDate}.csv`;
          }
          return '';
      };
      
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", filename());
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); 
    };
  

  return (
    <div className='title_wise_cutlistreport'>
       <Header>Title Productivity Report</Header>
    <div style={{display:"flex", alignItems: 'center', marginBottom:'20px'}}>
      <div style={{marginRight: "10px"}}>
          <label style={{fontWeight:"bold"}}>Report Type</label>
          <Dropdown
            clearable
            placeholder='Select an option'
            fluid
            search
            selection
            options={reportoptions}
            onChange={handleChangeReport}
            style={{width:"250px"}}
          />
     </div>
     {selectedReport === 'Title-Wise' ? (
      <>   
          <div style={{ marginRight: "10px" }}>
            <label style={{ fontWeight: "bold" }}>Title Code</label>
            <Dropdown
              clearable
              placeholder='Select an option'
              fluid
              search
              selection
              options={assignTitleCode}
              value={selectedTitle}
              onChange={handleChangeTitle}
              style={{ width: "250px" }} />
          </div>
          <div style={{ marginRight: "10px", alignSelf: 'end' }}>
              <Button primary onClick={handleViewReport}>View Report</Button>
              <Button style={{ width: '50px' }} onClick={handleDownloadReport}><Icon name='download' /></Button>
          </div>
      </> 
     ): null}
     {selectedReport === 'Date-Wise' ? (
        <>
            <div style={{ marginRight: "10px" }}>
              <label style={{ fontWeight: "bold" }}>From</label>
              <DatePicker
                selected={startDate ? moment(startDate, 'MM-DD-YYYY').toDate() : null}
                className="date-picker-style-m0"
                maxDate={moment().toDate()}
                onChange={(date: Date) => setDate(date, 'start')}
              />
            </div>
            <div style={{ marginRight: "10px" }}>
              <label style={{ fontWeight: "bold" }}>To</label>
              <DatePicker
                selected={endDate ? moment(endDate, 'MM-DD-YYYY').toDate() : null}
                className="date-picker-style-m0"
                maxDate={moment().toDate()}
                onChange={(date: Date) => setDate(date, 'end')}
              />
            </div>
            <div style={{ marginRight: "10px", alignSelf: 'end' }}>
                  <Button primary onClick={handleViewReport}>View Report</Button>
                  <Button style={{ width: '50px' }} onClick={handleDownloadReport}><Icon name='download' /></Button>
            </div>
        </>
     ): null}
    </div>
    {loading ? (
      <Loader active inline = 'centered'/>
    ):(
      <div>
        {selectedReport === 'Title-Wise' && (
           <div style={{ overflowY: 'auto', border: '1px solid #ccc', borderRadius: '5px', padding: '10px'}}>
              <Table compact>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Employee ID</Table.HeaderCell>
                    <Table.HeaderCell>Employee Name</Table.HeaderCell>
                    <Table.HeaderCell>Project Name</Table.HeaderCell>
                    <Table.HeaderCell>Approval Frames</Table.HeaderCell>
                    <Table.HeaderCell>Total Hours</Table.HeaderCell>
                    <Table.HeaderCell>Date Of Floor</Table.HeaderCell>
                    <Table.HeaderCell>Current Date</Table.HeaderCell>
                    <Table.HeaderCell>Tenure</Table.HeaderCell>
                    <Table.HeaderCell>Efficency</Table.HeaderCell>
                    <Table.HeaderCell>Estimate Hour</Table.HeaderCell>
                    <Table.HeaderCell>Total Frames</Table.HeaderCell>
                    <Table.HeaderCell>Target</Table.HeaderCell>
                    <Table.HeaderCell>Actual Target</Table.HeaderCell>
                    <Table.HeaderCell>Productivity %</Table.HeaderCell>
                    <Table.HeaderCell>Rejected Frames</Table.HeaderCell>
                    <Table.HeaderCell>Quality %</Table.HeaderCell>
                    <Table.HeaderCell>Artifacts Frames</Table.HeaderCell>
                    <Table.HeaderCell>Artifacts %</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {titleWise.length === 0 && (
                    <Table.Row>
                      <Table.Cell colSpan={18} textAlign="center">
                        No data available.
                      </Table.Cell>
                    </Table.Row>
                  )}
                  {titleWise.length > 0 && titleWise.map((data, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{data.employeeID}</Table.Cell>
                      <Table.Cell>{data.employeeName}</Table.Cell>
                      <Table.Cell>{data.project_Name}</Table.Cell>
                      <Table.Cell>{data.approved_Frame}</Table.Cell>
                      <Table.Cell>{data.totalHours}</Table.Cell>
                      <Table.Cell>{data.date_of_Floor}</Table.Cell>
                      <Table.Cell>{data.current_Date}</Table.Cell>
                      <Table.Cell>{data.tenure}</Table.Cell>
                      <Table.Cell>{data.efficency}</Table.Cell>
                      <Table.Cell>{data.est_Hour}</Table.Cell>
                      <Table.Cell>{data.total_frame}</Table.Cell>
                      <Table.Cell>{data.target_frame}</Table.Cell>
                      <Table.Cell>{data.actual_Target}</Table.Cell>
                      <Table.Cell>{data.productivity}</Table.Cell>
                      <Table.Cell>{data.rejectFrame}</Table.Cell>
                      <Table.Cell>{data.quality}</Table.Cell>
                      <Table.Cell>{data.artifactFrame}</Table.Cell>
                      <Table.Cell>{data.qualityofartifact}</Table.Cell>
                    </Table.Row>
                  ))}              
                </Table.Body> 
            </Table>
           </div>
         )}
         {selectedReport === 'Date-Wise' && (
          <div  style={{ overflowY: 'auto', border: '1px solid #ccc', borderRadius: '5px', padding: '10px'}}>
              <Table compact>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Employee ID</Table.HeaderCell>
                    <Table.HeaderCell>Employee Name</Table.HeaderCell>
                    <Table.HeaderCell>Project Name</Table.HeaderCell>
                    <Table.HeaderCell>Approval Frames</Table.HeaderCell>
                    <Table.HeaderCell>Total Hours</Table.HeaderCell>
                    <Table.HeaderCell>Date Of Floor</Table.HeaderCell>
                    <Table.HeaderCell>Current Date</Table.HeaderCell>
                    <Table.HeaderCell>Tenure</Table.HeaderCell>
                    <Table.HeaderCell>Efficency</Table.HeaderCell>
                    <Table.HeaderCell>Estimate Hour</Table.HeaderCell>
                    <Table.HeaderCell>Total Frames</Table.HeaderCell>
                    <Table.HeaderCell>Target</Table.HeaderCell>
                    <Table.HeaderCell>Actual Target</Table.HeaderCell>
                    <Table.HeaderCell>Productivity %</Table.HeaderCell>
                    <Table.HeaderCell>Rejected Frames</Table.HeaderCell>
                    <Table.HeaderCell>Quality %</Table.HeaderCell>
                    <Table.HeaderCell>Artifacts Frames</Table.HeaderCell>
                    <Table.HeaderCell>Artifacts %</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {dateWise.length === 0 && (
                    <Table.Row>
                      <Table.Cell colSpan={18} textAlign="center">
                        No data available.
                      </Table.Cell>
                    </Table.Row>
                  )}
                  {dateWise.length > 0 && dateWise.map((data, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{data.employee_Id}</Table.Cell>
                      <Table.Cell>{data.employee_Name}</Table.Cell>
                      <Table.Cell>{data.project_Name}</Table.Cell>
                      <Table.Cell>{data.approval_Frames}</Table.Cell>
                      <Table.Cell>{data.total_Hours}</Table.Cell>
                      <Table.Cell>{data.dof}</Table.Cell>
                      <Table.Cell>{data.current}</Table.Cell>
                      <Table.Cell>{data.tenure}</Table.Cell>
                      <Table.Cell>{data.efficency}</Table.Cell>
                      <Table.Cell>{data.est_Hour}</Table.Cell>
                      <Table.Cell>{data.total_Framess}</Table.Cell>
                      <Table.Cell>{data.target}</Table.Cell>
                      <Table.Cell>{data.actualTarget}</Table.Cell>
                      <Table.Cell>{data.productivity_percentage}</Table.Cell>
                      <Table.Cell>{data.sum_of_Rejected_Frames}</Table.Cell>
                      <Table.Cell>{data.quality_percentage}</Table.Cell>
                      <Table.Cell>{data.artifacts_Rejected_Frames}</Table.Cell>
                      <Table.Cell>{data.artifacts_Rejection_percentage}</Table.Cell>
                    </Table.Row>
                  ))}              
                </Table.Body> 
            </Table>
          </div>
         )}
      </div>
    )}
    </div>
  )
}

export default TitleProductivityReport